import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RuleForm from '../inputs/RuleForm';

class PriceToInvoiceMismatchRule extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onReset = this.onReset.bind(this);
    const { initialValues } = props;
    this.initialState = {
      supplier: initialValues.supplier || 1
    };
    this.state = this.initialState;
  }

  onSubmit(event) {
    event.preventDefault();
    this.props.onSubmit({
      kind: 'price_to_invoice_mismatch',
      value: this.state
    });
  }

  onReset() {
    this.setState(this.initialState);
  }

  render() {
    const { type, ...other } = this.props;

    return (
      <RuleForm
        {...other}
        onSubmit={e => e.preventDefault()}
        onReset={this.onReset}
        disabled={true}
      >

      </RuleForm>
    );
  }
}

PriceToInvoiceMismatchRule.defaultProps = {
  type: 'add',
  initialValues: {}
};

PriceToInvoiceMismatchRule.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  type: PropTypes.string,
  initialValues: PropTypes.object,
};

export default PriceToInvoiceMismatchRule;
